import { useEffect, useState } from 'react';
import { CALENDAR_TYPE, RELEASE_TYPE } from '../../constants/myBlockMonth';
import { getStripCalendarCapsuleWidth } from '../../pages/MyBlockMonth/myBlockMonthHelper';
import './CalendarReleaseCapsule.scss';
import { getReleaseMeasurements } from './CalendarReleaseCapsuleHelper';
interface Props {
    blockDate?: any
    calendarElementWidth?: number
    calendarType: string
    event?: any
    pairingReleaseWidth?: number
}

const CalendarReleaseCapsule = ({blockDate, calendarElementWidth, calendarType, event, pairingReleaseWidth}: Props) => {  
    
    const [releaseWidth, setReleaseWidth] = useState({
        start: 0, 
        end: 0
    });

    useEffect(() => {
        if(!pairingReleaseWidth && event) getCapsule();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getCapsule = () => {
        const eventCntrWidthPx = calendarType === CALENDAR_TYPE.STRIP ? document.getElementsByClassName('c-body__inner')[0].clientWidth : document.getElementsByClassName('c-dates-grid')[0].clientWidth/7;
        const capsuleWidth = calendarType === CALENDAR_TYPE.STRIP ? getStripCalendarCapsuleWidth(false, false, event, blockDate, calendarElementWidth) : event.stdCalWidthPct;
        if(eventCntrWidthPx) {
          let releaseStartWidth = event.hasStartRelease ? getReleaseMeasurements(event, RELEASE_TYPE.START_WIDTH, 0) : 0
          let releaseEndWidth = event.hasEndRelease ? getReleaseMeasurements(event,RELEASE_TYPE.END_WIDTH, event.release.length-1) : 0;
          const capsuleWidthPx = (capsuleWidth/100) * eventCntrWidthPx; 
            if(event.hasStartRelease) {
                const startReleaseWidthPx = (releaseStartWidth/100) * capsuleWidthPx;
                releaseStartWidth = (startReleaseWidthPx/capsuleWidthPx)*100;
            }
            if(event.hasEndRelease) {
                const endReleaseWidthPx = (releaseEndWidth/100) * capsuleWidthPx;
                releaseEndWidth = (endReleaseWidthPx/capsuleWidthPx)*100;
            }
            setReleaseWidth({
                start: releaseStartWidth,
                end: releaseEndWidth
            })
        }
      }

    return (
        <>
            {pairingReleaseWidth ? <div className='capsule__release release--start' style={{width: pairingReleaseWidth+'px'}}/> : null}
            {!pairingReleaseWidth && event?.hasStartRelease ? <div className='capsule__release release--start' style={{width: releaseWidth.start+'%'}}/> : null}
            {!pairingReleaseWidth && event?.hasEndRelease ? <div className='capsule__release release--end' style={{left: getReleaseMeasurements(event, RELEASE_TYPE.END_MARGIN_LEFT, event.release.length-1)+'%', width: releaseWidth.end+'%'}}/> : null}
            {!pairingReleaseWidth && event?.release.filter(rel => rel.releaseType === RELEASE_TYPE.MIDDLE).length > 0 ? event.release.filter(rel => rel.releaseType=== RELEASE_TYPE.MIDDLE).map(rel => {
                return <div className='capsule__release' style={{left: getReleaseMeasurements(event, RELEASE_TYPE.MIDDLE_MARGIN_LEFT, event.release.findIndex(r => r.unique_id === rel.unique_id))+'%', width: getReleaseMeasurements(event, RELEASE_TYPE.MIDDLE_WIDTH, event.release.findIndex(r => r.unique_id === rel.unique_id))+'%'}}/>}) : null
            }
        </>
    )
}

export default CalendarReleaseCapsule;